export default __webpack_public_path__ + "static/media/Group 3404.c9db7e12.png";